import { render, staticRenderFns } from "./DashboardVoiceXBarAndLineGraph.vue?vue&type=template&id=23e18873&scoped=true&"
import script from "./DashboardVoiceXBarAndLineGraph.vue?vue&type=script&lang=ts&"
export * from "./DashboardVoiceXBarAndLineGraph.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardVoiceXBarAndLineGraph.vue?vue&type=style&index=0&id=23e18873&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e18873",
  null
  
)

export default component.exports